import axios from "axios"; import Swal from "sweetalert2"; import { store } from "../App"; import LogOut from "../Components/Logout"; import { LOGIN_DOMAIN } from "./Configuration";

const axiosTokenServiceKeyCloak = axios.create();

axiosTokenServiceKeyCloak.interceptors.response.use(
  async (config) => {
    return config;
  },
  function (error) {
    if (error?.response?.status === 401) {
      Swal.fire({ icon: "error", title: "Session Expired", confirmButtonText: "OK", }).then((result) => { if (result.isConfirmed) { store.dispatch({ type: LogOut }); window.location.href=LOGIN_DOMAIN } }); } else if (error?.response?.status === 500) { }
    return Promise.reject(error);
  }
);


axiosTokenServiceKeyCloak.interceptors.request.use(
  async (config) => {
   
    const token =
      "Bearer" + " " + localStorage?.getItem("keycloaktoken").replace(/['"]+/g, "");
    config.headers.Authorization = token;
    
    return config;
  },
  function (error) {
    if (error?.response?.status === 401) {
      Swal.fire({ icon: "error", title: "Session Expired", confirmButtonText: "OK", }).then((result) => {
        if (result.isConfirmed) { } });
    } else if (error?.response?.status === 500) { } return Promise.reject(error);
  }
);

export default axiosTokenServiceKeyCloak;
